export const SpeechBuble = ({ className = '' }) => (
  <svg className={className} fill="#EB5369" width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" >
    <path d="M0 2.7907C0 1.24944 1.22104 0 2.72727 0H12.2727C13.779 0 15 1.24944 15 2.7907L15 8.37209C15 9.91335 13.779 11.1628 12.2727 11.1628H10.9091V15L4.77274 11.1628H2.72727C1.22104 11.1628 0 9.91335 0 8.37209C0 6.51163 0 4.65116 0 2.7907Z" fill="#EB5369"/>
  </svg>
);
